import { render, staticRenderFns } from "./CommercialPolicyInfo.vue?vue&type=template&id=727e1733&scoped=true&"
import script from "./CommercialPolicyInfo.vue?vue&type=script&lang=js&"
export * from "./CommercialPolicyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727e1733",
  null
  
)

export default component.exports